import React from "react";
import BreadCrumb from "../BreadCrumb";
import { YMaps, Map, Placemark, ZoomControl } from "@pbe/react-yandex-maps";

import { GrLocation } from "@react-icons/all-files/gr/GrLocation";
import { GrPhone } from "@react-icons/all-files/gr/GrPhone";
import { GrShareOption } from "@react-icons/all-files/gr/GrShareOption";
import { GrFacebookOption } from "@react-icons/all-files/gr/GrFacebookOption";
import { GrTwitter } from "@react-icons/all-files/gr/GrTwitter";
import { GrInstagram } from "@react-icons/all-files/gr/GrInstagram";
import themes from "../../themes/themes";
import Link from "next/link";
import { useTranslation } from "../../context/TranslationContext";

const Contact = ({ ssr, isAppWebView }) => {
  const {
    contactAddress,
    contactPhoneEmail,
    contactShare,
    contactForm,
    contactFullName,
    contactPhone,
    contactEmail,
    contactSubject,
    contactMessage,
    contactSecurityCode,
    contactSecurityCodeEnter,
    contactSendForm,
    contactMap,
  } = useTranslation();
  return (
    <>
      <BreadCrumb data={ssr.result.BreadCrumb} isAppWebView={isAppWebView} />
      <div className="contact_item mb-6">
        <div className="container">
          <div className="grid lg:grid-cols-3 gap-7 mb-8">
            <div className="contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-9 gap-y-2 shadow-xl">
              <GrLocation className="w-10 h-10" />
              <strong className={`text-25 font-medium ${themes.colorContent}`}>
                {contactAddress}
              </strong>
              <span>{ssr.result.adres}</span>
            </div>
            <div className="contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-7 gap-y-2 shadow-xl">
              <GrPhone className="w-10 h-10" />
              <strong className={`${themes.colorContent} text-25 font-medium`}>
                {contactPhoneEmail}
              </strong>
              <span>
                {ssr.result.phone} <br></br> {ssr.result.sitemail}
              </span>
            </div>
            <div className="contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-7 gap-y-2 shadow-xl">
              <GrShareOption className="w-10 h-10" />
              <strong className={`${themes.colorContent} text-25 font-medium`}>
                {contactShare}
              </strong>
              <div className="flex items-center gap-x-2">
                {ssr.result.facebook && (
                  <Link href={ssr.result.facebook}>
                    <a
                      title={process.env.NEXT_PUBLIC_SITENAME + " Facebook"}
                      target={"_blank"}
                      rel="nofollow"
                      className="w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full"
                    >
                      <GrFacebookOption className="text-white" />
                    </a>
                  </Link>
                )}

                {ssr.result.twitter && (
                  <Link href={ssr.result.twitter}>
                    <a
                      title={process.env.NEXT_PUBLIC_SITENAME + " Twitter"}
                      target={"_blank"}
                      rel="nofollow"
                      className="w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full"
                    >
                      <GrTwitter className="text-white" />
                    </a>
                  </Link>
                )}
                {ssr.result.instagram && (
                  <Link href={ssr.result.instagram}>
                    <a
                      title={process.env.NEXT_PUBLIC_SITENAME + " Instagram"}
                      target={"_blank"}
                      rel="nofollow"
                      className="w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full"
                    >
                      <GrInstagram className="text-white" />
                    </a>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-x-5">
            <div className="lg:col-span-6 col-span-12 mb-5">
              <div className="item-form p-5 shadow-xl">
                <h2 className="text-25 font-semibold border-b border-black pb-1	mb-5">
                  {contactForm}
                </h2>
                <form className="">
                  <div className="grid sm:grid-cols-2 gap-x-5 mb-5">
                    <label className="flex flex-col font-semibold sm:mb-0 mb-2">
                      {contactFullName}
                      <input
                        type="text"
                        name="name"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        autoComplete="off"
                      />
                    </label>
                    <label className="flex flex-col font-semibold">
                      {contactPhone}
                      <input
                        type="text"
                        name="name"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        autoComplete="off"
                      />
                    </label>
                  </div>
                  <div className="grid sm:grid-cols-2 gap-x-5 mb-5">
                    <label className="flex flex-col font-semibold sm:mb-0 mb-2">
                      {contactEmail}
                      <input
                        type="text"
                        name="name"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        autoComplete="off"
                      />
                    </label>
                    <label className="flex flex-col font-semibold">
                      {contactSubject}
                      <input
                        type="text"
                        name="name"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        autoComplete="off"
                      />
                    </label>
                  </div>
                  <label className="flex flex-col font-semibold mb-5">
                    {contactMessage}
                    <textarea
                      name="mesaj"
                      className="focus:outline-none border pl-2"
                      cols="10"
                      rows="5"
                      required=""
                    ></textarea>
                  </label>
                  <div className="grid sm:grid-cols-2 gap-x-5 mb-5">
                    <label className="flex flex-col font-semibold sm:mb-0 mb-2">
                      {contactSecurityCode}
                      <input
                        type="text"
                        name="sayi"
                        value="1184"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        readOnly
                      />
                    </label>
                    <label className="flex flex-col font-semibold">
                      {contactSecurityCodeEnter}
                      <input
                        type="text"
                        name="name"
                        className="border border-1 focus:outline-none pl-2 py-2"
                        autoComplete="off"
                      />
                    </label>
                  </div>
                  <button
                    type="submit"
                    className="submitBtn w-full py-4 bg-green-500 hover:bg-[#28a745] ease-linear duration-200 font-semibold text-white rounded-md disabled"
                  >
                    {contactSendForm}
                  </button>
                </form>
              </div>
            </div>
            <div className="lg:col-span-6 col-span-12">
              <div className="item-map p-5 shadow-xl w-full h-full">
                <h2 className="text-25 font-semibold border-b border-black pb-1	mb-5">
                  {contactMap}
                </h2>
                <YMaps
                  className="w-full h-full"
                  query={{
                    lang: process.env.NEXT_PUBLIC_LANGUAGE === "en" ? "en_US" : "tr_TR",
                    scroll: false,
                  }}
                >
                  <Map
                    instanceRef={(ref) => {
                      ref && ref.behaviors.disable("scrollZoom");
                    }}
                    width="100%"
                    height={366}
                    defaultState={{
                      center: [36.6489397157294, 29.131687804566646],
                      zoom: 14,
                    }}
                  >
                    <Placemark
                      geometry={[36.6489397157294, 29.131687804566646]}
                    />
                    <ZoomControl></ZoomControl>
                  </Map>
                </YMaps>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
